import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingState } from '../../../core/panels/loading-panel.component';
import { CardComponent } from '../../../core/panels/card.component';
import { DetailPanelComponent } from '../../../core/panels/detail-panel/detail-panel.component';
import { DetailItemComponent } from '../../../core/panels/detail-panel/detail-item.component';
import { Payment } from '../../../../models/api/view/claim/financials/payment-history/payment';
import { EmptyStateComponent } from '../../../core/panels/empty-state.component';
import { ProgressbarComponent } from '../../../core/labels/progressbar.component';

@Component({
  selector: 'app-payment-info-section',
  standalone: true,
  imports: [
    CommonModule,
    CardComponent,
    DetailPanelComponent,
    DetailItemComponent,
    EmptyStateComponent,
    ProgressbarComponent,
  ],
  template: `
    <app-card label="Payment information">
      @if (state === 'Loading') {
        <app-empty-state
          height="250px"
          icon="fa-light fa-file-arrow-down"
          label="Loading payment"
          message="Retrieving from payment repository"
        >
          <div class="tw-py-4">
            <app-progressbar />
          </div>
        </app-empty-state>
      } @else {
        @if (paymentData) {
          <div class="tw-flex tw-gap-8">
            <div class="tw-basis-1/3">
              <app-detail-panel [dataSource]="paymentData">
                <app-detail-item label="Document type" name="docType" />
                <app-detail-item label="Bank account" name="bankNum" />
                <app-detail-item
                  label="Check cleared"
                  name="chkCleared"
                  format="b"
                />
                <app-detail-item label="Payment method" name="payVia" />
                <app-detail-item labelCase="none" label="Tax ID" name="taxId" />
                <app-detail-item label="Payee" name="payee" />
              </app-detail-panel>
              <app-detail-panel [dataSource]="paymentData">
                <app-detail-item label="Mailing address" name="address" />
              </app-detail-panel>
            </div>
            <div class="tw-basis-1/3">
              <app-detail-panel [dataSource]="paymentData">
                <app-detail-item label="Payment type" name="paymentType" />
                <app-detail-item
                  labelCase="none"
                  label="Check/ACH #"
                  name="checkNum"
                />
                <app-detail-item
                  label="Check cleared date"
                  name="dateClear"
                  format="d"
                />
                <app-detail-item
                  label="Date voided"
                  name="dateVoid"
                  format="d"
                />
                <app-detail-item
                  label="1099 exempt"
                  name="ind1099"
                  format="b"
                />
                <app-detail-item
                  label="Schedule date"
                  name="dateScheduled"
                  format="d"
                />
              </app-detail-panel>
            </div>
            <div class="tw-basis-1/3">
              <app-detail-panel [dataSource]="paymentData">
                <app-detail-item
                  labelCase="none"
                  label="Check/ACH total"
                  name="paidTotal"
                  format="c"
                />
                <app-detail-item label="Comments" name="payComments" />
                <app-detail-item label="Payee type" name="nameType" />
                <app-detail-item label="Unallocated" name="unalloc" />
                <app-detail-item
                  name="dateMailed"
                  label="Mail date"
                  format="d"
                />
              </app-detail-panel>
            </div>
          </div>
        } @else {
          <app-empty-state
            height="250px"
            icon="fa-light fa-file-arrow-down"
            label="No payment information available"
            message="There is no payment data for this bill"
          />
        }
      }
    </app-card>
  `,
})
export class PaymentInfoSectionComponent {
  @Input() paymentData: Payment | null = null;
  @Input() state: LoadingState = 'Loading';
}
